module.exports = __webpack_public_path__ + "img/12.fbef0342.jpg";